<template>
    <div class="container">
        <el-container style="height: 100%; border: 1px solid #eee">
            <div style="border-right: 1px solid #eee">
                <!--overflow-y:auto;height:800px-->
                <div style="margin: 13px 13px; height: 40px; width: 183px">
                    <el-input placeholder="输入关键字进行过滤" clearable maxlength="20" v-model="filterText"></el-input>
                </div>
                <div v-if="treeData.length > 0" style="height: 640px; overflow-y: auto">
                    <el-aside width="210px" style="background-color: rgb(238, 241, 246)">
                        <el-tree
                            class="filter-tree"
                            ref="tree"
                            :data="treeData"
                            :default-expanded-keys="defaultShowNodes"
                            :default-expand-all="false"
                            :highlight-current="true"
                            node-key="id"
                            :filter-node-method="filterNode"
                            @node-click="handleNodeClick"
                        ></el-tree>
                    </el-aside>
                </div>
                <div v-else style="width: 200px; text-align: center; color: red">
                    请先添加关联数据，校区、教学楼、教室、学科、教师！
                </div>
            </div>

            <el-container>
                <el-header style="text-align: right; font-size: 16px; color: #333">
                    <el-row>
                        <el-col :span="14">
                            <div style="text-align: left">
                                {{
                                    buildingForm.campus_name +
                                    ' - ' +
                                    buildingForm.building_name +
                                    ' - ' +
                                    buildingForm.floor_name +
                                    ' - ' +
                                    buildingForm.classroom_name
                                }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <el-select
                                v-model="formSearch.term_id"
                                clearable
                                filterable
                                @change="
                                    (pre) => {
                                        selectTerm(pre)
                                    }
                                "
                                placeholder="学年学期"
                            >
                                <el-option
                                    v-for="item in all_term_map[buildingForm.campus_id]"
                                    :key="item.term"
                                    :label="item.period_name + '~' + item.term_name"
                                    :value="item.term"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="5">
                            <el-select v-model="currentWeek" clearable filterable placeholder="周">
                                <el-option
                                    v-for="item in weeksCount"
                                    :key="item"
                                    :label="'第' + item + '周'"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-header>

                <el-main style="margin-top: -20px">
                    <el-table
                        ref="table"
                        :data="table_data"
                        border
                        :header-cell-style="{
                            background: '#dcdfe6',
                            color: '#333'
                        }"
                        :cell-style="cellStyle"
                        @cell-click="clickTableCell"
                        style="width: 100%"
                    >
                        <el-table-column fixed prop="class_items" label="" align="center" min-width="10%"></el-table-column>
                        <el-table-column prop="week1" label="星期一" header-align="center" min-width="13%">
                            <template #scope="scope">
                                <div v-for="(item, index) in scope.row.week1" :key="index">
                                    <div>
                                        <i class="el-icon-s-management"></i>
                                        {{ item.subName }}
                                    </div>
                                    <div>
                                        <i class="el-icon-user-solid"></i>
                                        {{ item.teacherName }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="week2" label="星期二" header-align="center" min-width="13%">
                            <template #scope="scope">
                                <div v-for="(item, index) in scope.row.week2" :key="index">
                                    <div>
                                        <i class="el-icon-s-management"></i>
                                        {{ item.subName }}
                                    </div>
                                    <div>
                                        <i class="el-icon-user-solid"></i>
                                        {{ item.teacherName }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="week3" label="星期三" header-align="center" min-width="13%">
                            <template #scope="scope">
                                <div v-for="(item, index) in scope.row.week3" :key="index">
                                    <div>
                                        <i class="el-icon-s-management"></i>
                                        {{ item.subName }}
                                    </div>
                                    <div>
                                        <i class="el-icon-user-solid"></i>
                                        {{ item.teacherName }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="week4" label="星期四" header-align="center" min-width="13%">
                            <template #scope="scope">
                                <div v-for="(item, index) in scope.row.week4" :key="index">
                                    <div>
                                        <i class="el-icon-s-management"></i>
                                        {{ item.subName }}
                                    </div>
                                    <div>
                                        <i class="el-icon-user-solid"></i>
                                        {{ item.teacherName }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="week5" label="星期五" header-align="center" min-width="13%">
                            <template #scope="scope">
                                <div v-for="(item, index) in scope.row.week5" :key="index">
                                    <div>
                                        <i class="el-icon-s-management"></i>
                                        {{ item.subName }}
                                    </div>
                                    <div>
                                        <i class="el-icon-user-solid"></i>
                                        {{ item.teacherName }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="week6" label="星期六" header-align="center" min-width="13%">
                            <template #scope="scope">
                                <div v-for="(item, index) in scope.row.week6" :key="index">
                                    <div>
                                        <i class="el-icon-s-management"></i>
                                        {{ item.subName }}
                                    </div>
                                    <div>
                                        <i class="el-icon-user-solid"></i>
                                        {{ item.teacherName }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="week7" label="星期日" header-align="center" min-width="13%">
                            <template #scope="scope">
                                <div v-for="(item, index) in scope.row.week7" :key="index">
                                    <div>
                                        <i class="el-icon-s-management"></i>
                                        {{ item.subName }}
                                    </div>
                                    <div>
                                        <i class="el-icon-user-solid"></i>
                                        {{ item.teacherName }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
            </el-container>
            <!--add-->
            <div style="border-left: 1px solid #eee">
                <!--overflow-y:auto;height:800px-->

                <el-aside width="290px" style="background-color: #fff">
                    <el-row>
                        <el-col :span="19">
                            <div
                                style="
                                    padding: 10px 13px 1px 13px;
                                    height: 35px;
                                    width: 223px;
                                    color: #333;
                                    border-bottom: 1px solid #eee;
                                "
                            >
                                课表详情
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div style="padding-top: 5px">
                                <el-button type="primary" size="default" @click="addObject">添加</el-button>
                            </div>
                        </el-col>
                    </el-row>

                    <el-form :model="addForm" label-position="left" label-width="72px" ref="addForm">
                        <el-row style="padding: 5px 10px" type="flex" justify="space-between">
                            <el-col :span="24" style="color: var(--theme-color)">
                                <i class="el-icon-date"></i>
                                学科信息
                            </el-col>
                            <el-col :span="2"><i class="el-icon-delete" @click="deleteSubject(0)"></i></el-col>
                        </el-row>
                        <el-form-item label="学年学期" style="padding-left: 10px" prop="termInfo">
                            <el-row>
                                <el-col :span="24">
                                    <div style="color: #333">
                                        {{ ':  ' + addForm.termInfo }}
                                    </div>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="教室" style="padding-left: 10px" prop="classroom_name">
                            <el-row>
                                <el-col :span="24">
                                    <div style="color: #333">
                                        {{
                                            buildingForm.campus_name +
                                            '-' +
                                            buildingForm.building_name +
                                            '-' +
                                            buildingForm.floor_name +
                                            '-' +
                                            buildingForm.classroom_name
                                        }}
                                    </div>
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <el-form-item label="上课星期" style="padding-left: 10px" prop="subject_name">
                            <el-row>
                                <el-col :span="24">
                                    <el-select
                                        v-model="selectWeek"
                                        clearable
                                        filterable
                                        placeholder="请选择"
                                        @change="onWeekChange"
                                    >
                                        <el-option
                                            v-for="item in weekList"
                                            :key="item.id"
                                            :label="item.label"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="课次" style="padding-left: 10px" prop="rank">
                            <el-row>
                                <el-col :span="24">
                                    <!-- <div style="color: #333">
                    {{ addForm.rankStr }}
                  </div> -->
                                    <el-select
                                        v-model="addForm.rank"
                                        clearable
                                        filterable
                                        placeholder="请选择课次"
                                        @change="onRankChange"
                                    >
                                        <el-option
                                            v-for="item in rank_lisk"
                                            :key="item.id"
                                            :label="item.rank"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <el-form-item label="学科名称" style="padding-left: 10px" prop="subject_name">
                            <el-row>
                                <el-col :span="24">
                                    <el-select
                                        v-model="subject_id"
                                        clearable
                                        filterable
                                        remote
                                        :remote-method="remoteQuerySubject"
                                        :loading="querySubjectLoading"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="item in subjectList"
                                            :key="item.id"
                                            :label="item.subject_name + (item.subject_code ? '(' + item.subject_code + ')' : '')"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <el-form-item label="教师姓名" style="padding-left: 10px" prop="teacher_name">
                            <el-row>
                                <el-col :span="24">
                                    <el-select
                                        v-model="teacher_id"
                                        clearable
                                        filterable
                                        remote
                                        :remote-method="remoteQueryTeacher"
                                        :loading="queryTeacherLoading"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="item in teacherList"
                                            :key="item.id"
                                            :label="item.ad_name + '(' + item.ad_number + ')'"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <el-form-item label="上课人数" style="padding-left: 10px" prop="teacher_name">
                            <el-row>
                                <el-col :span="24">
                                    <el-input v-model="students_num" clearable filterable placeholder="请输入上课人数"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <div style="padding: 10px; font-size: 14px; color: #606266">
                            <span style="margin-right: 26px">上课周</span>
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                                全选
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 10px">
                            <el-checkbox-group
                                v-model="checkboxGroup2"
                                size="default"
                                :disabled="!selectWeek"
                                @change="handleCheckedWeekChange"
                            >
                                <el-checkbox-button
                                    v-for="weeks in weeksCount"
                                    :label="weeks"
                                    :key="weeks"
                                    :disabled="disabled_selected_week.includes(weeks)"
                                >
                                    {{ weeks }}
                                </el-checkbox-button>
                            </el-checkbox-group>
                        </div>

                        <el-row style="margin: 10px 0">
                            <el-col :span="12" style="text-align: center">
                                <el-button :disabled="operateDisableFlag" type="warning" @click="clickCommitBtn1">提交</el-button>
                            </el-col>
                            <el-col :span="12" style="text-align: center">
                                <el-button :disabled="operateDisableFlag" type="warning" plain @click="clickCommitcancel">
                                    取消
                                </el-button>
                            </el-col>
                        </el-row>
                        <el-row style="margin: 10px 0">
                            <el-col style="text-align: center">
                                <el-button
                                    v-if="
                                        this.subjectDataArr &&
                                        this.subjectDataArr.length &&
                                        this.subjectDataArr.length > 1 &&
                                        this.index !== 0
                                    "
                                    @click="clickPreviousCourse"
                                >
                                    上一条
                                </el-button>
                                <el-button
                                    v-if="
                                        this.subjectDataArr &&
                                        this.subjectDataArr.length &&
                                        this.subjectDataArr.length > 1 &&
                                        this.index !== this.subjectDataArr.length - 1
                                    "
                                    @click="clickNextCourse"
                                >
                                    下一条
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-aside>
            </div>
        </el-container>
    </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios'

export default {
    name: 'user',
    data() {
        return {
            index: 0, //  课程下标
            rank_lisk: [],
            summer_winter: {
                summer_end_time: '',
                summer_name: '',
                summer_start_time: '',
                winter_name: '',
                summer_daily_end: '',
                summer_daily_start: '',
                winter_daily_end: '',
                winter_daily_start: ''
            },
            selectWeek: '',
            selected_week: [],
            subject_id: '',
            teacher_id: '',
            schedule_id: '',
            students_num: 0,
            checkboxGroup2: [],
            disabled_selected_week: [],
            weekList: [
                { label: '星期一', id: 1 },
                { label: '星期二', id: 2 },
                { label: '星期三', id: 3 },
                { label: '星期四', id: 4 },
                { label: '星期五', id: 5 },
                { label: '星期六', id: 6 },
                { label: '星期七', id: 7 }
            ],
            filterText: '',
            formSearch: {
                term_id: '',
                termStr: ''
            },
            responseData: [],
            responseInitData: [
                {
                    // 课次
                    class_rank_name: '第1~2节',
                    schedule_detail: [[], [], [], [], [], [], []]
                },
                {
                    class_rank_name: '第3~4节',
                    schedule_detail: [[], [], [], [], [], [], []]
                },
                {
                    class_rank_name: '第5~6节',
                    schedule_detail: [[], [], [], [], [], [], []]
                },
                {
                    class_rank_name: '第7~8节',
                    schedule_detail: [[], [], [], [], [], [], []]
                },
                {
                    class_rank_name: '第9~10节',
                    schedule_detail: [[], [], [], [], [], [], []]
                }
            ],
            startResponseData: [], // 保存原始课程信息数据
            isChangeData: false,
            subjectDataArr: [],
            table_data: [],
            treeData: [],

            addForm: {
                term_id: '',
                classroom_id: '',
                rank: '',
                week_day: '',
                // 以下用来显示
                classroom_name: '',
                floor_name: '',
                building_name: '',
                termInfo: '',
                rankStr: ''
            },
            buildingForm: {
                building_id: '',
                building_name: '',
                campus_id: '',
                campus_name: '',
                floor_id: '',
                floor_name: '',
                classroom_id: '',
                classroom_name: ''
            },
            termList: [],
            subjectList: [],
            querySubjectLoading: false,
            teacherList: [],
            queryTeacherLoading: false,
            buildingList: [],
            isEditSubjectInfo: false,
            row: null,
            column: null,
            rowIndex: 0,
            columnIndex: 0,
            mainHeight: window.innerHeight,
            isInputError: 0,
            weeksCount: 1,
            currentWeek: 1,
            defaultShowNodes: [],
            clickId: '',
            all_term_map: {},
            cellRowIndex: 0,
            cellColIndex: 1,
            operateDisableFlag: false,
            checkAll: false,
            isIndeterminate: false,
            value: true
        }
    },
    watch: {
        'buildingForm.campus_id'() {
            if (this.all_term_map[this.buildingForm.campus_id] && this.all_term_map[this.buildingForm.campus_id].length > 0) {
                this.all_term_map[this.buildingForm.campus_id].map((item) => {
                    if (item.is_current) {
                        this.formSearch.term_id = item.term
                    }
                })
                if (!this.formSearch.term_id) {
                    this.formSearch.term_id = this.all_term_map[this.buildingForm.campus_id][0]['term']
                }
                this.getAllTeacherList(this.buildingForm.campus_id)
                this.selectTerm(this.formSearch.term_id)
                this.operateDisableFlag = false
            } else {
                this.$message({
                    message: '请先为该校区添加学年学期！!',
                    type: 'warning'
                })
                this.operateDisableFlag = true
            }
        },
        selectWeek() {
            this.get_disable_week()
        },
        addForm: {
            deep: true,
            handler: function () {
                this.get_disable_week()
            }
        },
        currentWeek: {
            deep: true,
            handler: function () {
                this.checkboxGroup2 = []
                this.getTableList(this.formSearch)
            }
        },
        treeData: {
            deep: true,
            handler: function () {
                //  this.treeData.forEach((item) => {
                //    this.defaultShowNodes.push(this.getTreeDataOne(this.treeData, 0));
                //  });
                this.getTreeDataOne(this.treeData[0])
            }
        },
        filterText(val) {
            this.$refs.tree.filter(val)
        },
        teacher_id(newVal) {
            this.getAllTeacherList()
        }
    },
    mounted() {
        Promise.all([this.get_term(), this.getTreeBuildingList()]).then(([res1, res2]) => {
            if (res1.data.code === 0) {
                this.all_term_map = res1.data.data
            } else {
                this.$message({ message: res1.data.msg, type: 'error' })
            }
            if (res2.data.code === 0) {
                this.treeData = res2.data.data
                //  this.treeData = res2.data.data.filter(item => {
                //    return this.all_term_map[item.id]
                //  });
                this.$nextTick().then(() => {
                    setTimeout(() => {
                        const firstNode = document.querySelector(
                            '.el-tree-node .el-tree-node__children .is-expanded .is-expanded .is-expanded'
                        )
                        firstNode && firstNode.click()
                    }, 10)
                })
            } else {
                this.$message({ message: res2.data.msg, type: 'error' })
            }
        })
        this.getAllSubjectList()
        this.mainHeight = this.mainHeight - 200
        // 测试组装数据
        this.handleTableData(this.responseData)
    },
    methods: {
        //  获取所有的教室树
        getTreeBuildingList() {
            return Axios.get('/basic/schedule/tree')
            //  .then((resp) => {
            //    if (resp.data.code ===0) {
            //      this.treeData = resp.data.data;
            //      this.$nextTick().then(() => {
            //        setTimeout(() => {
            //          const firstNode = document.querySelector(
            //            ".el-tree-node .el-tree-node__children .is-expanded .is-expanded .is-expanded"
            //          );
            //          firstNode.click();
            //        }, 10);
            //      });
            //    } else {
            //      this.$message({ message: resp.data.msg, type: "error" });
            //    }
            //  })
            //  .catch((error) => {
            //    console.log(error);
            //  });
        },
        //  获取所有校区的学年学期集合
        get_term() {
            return Axios.get('/basic/schedule/term')
            //  .then((resp) => {
            //    if (resp.data.code ===0) {
            //      this.all_term_map = resp.data.data;
            //    } else {
            //      this.$message({ message: resp.data.msg, type: "error" });
            //    }
            //  })
            //  .catch((error) => {
            //    this.listLoading = false;
            //    console.log(error);
            //  });
        },

        set_rank_lisk(data) {
            this.rank_lisk = []
            data.map((item, index) => {
                this.rank_lisk.push({
                    rank: item.rank,
                    id: index
                })
            })
        },
        set_summer_winter(data) {
            if (data.summer_start_time) {
                this.summer_winter.summer_start_time = data.summer_start_time
                this.summer_winter.summer_end_time = data.summer_end_time
                this.summer_winter.summer_name = data.summer_name
                this.summer_winter.winter_name = data.winter_name
            } else {
                this.summer_winter.summer_daily_end = data.summer_daily_end
                this.summer_winter.summer_daily_start = data.summer_daily_start
                this.summer_winter.winter_daily_end = data.winter_daily_end
                this.summer_winter.winter_daily_start = data.winter_daily_start
            }
        },
        getTreeDataOne(data) {
            if (data) {
                this.defaultShowNodes.push(data.id)
                if (data.children) {
                    this.getTreeDataOne(data.children[0])
                }
            }
        },
        /**** 网络请求相关 */
        getTableList(search) {
            if (!this.buildingForm.classroom_id) {
                return
            }
            if (!search.term_id) {
                return
            }
            this.listLoading = false
            Axios.get('/basic/schedule/list_schedule', {
                params: {
                    room: this.buildingForm.classroom_id,
                    term: search.term_id,
                    week: this.currentWeek
                }
            })
                .then((resp) => {
                    this.listLoading = false
                    if (resp.data.code === 0) {
                        this.responseData = resp.data.data
                        this.startResponseData = JSON.parse(JSON.stringify(resp.data.data))
                        this.handleTableData(this.responseData)
                        this.disabled_selected_week = []
                        this.subjectDataArr = []
                    } else {
                        this.$message({
                            message: resp.data.msg,
                            type: 'error'
                        })
                    }
                })
                .catch((error) => {
                    this.listLoading = false
                    console.log(error)
                })
        },

        getAllSubjectList() {
            Axios.get('/basic/subject/list_subject', {
                params: {
                    page: 1,
                    page_size: 100
                }
            })
                .then((resp) => {
                    if (resp.data.code === 0) {
                        this.subjectList = resp.data.data.lists
                    } else {
                        this.$message({
                            message: resp.data.msg,
                            type: 'error'
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        remoteQuerySubject(query) {
            if (query !== '') {
                this.querySubjectLoading = true
                Axios.get('/basic/subject/query_subject', {
                    params: {
                        keyword: query
                    }
                })
                    .then((resp) => {
                        this.querySubjectLoading = false
                        if (resp.data.code === 0) {
                            this.subjectList = resp.data.data && resp.data.data.lists
                        } else {
                            this.$message({
                                message: resp.data.msg,
                                type: 'error'
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.getAllSubjectList()
            }
        },
        getAllTeacherList(campus = '') {
            Axios.get('/basic/teacher/list_teacher', {
                params: {
                    campus: campus,
                    page: -1
                }
            })
                .then((resp) => {
                    if (resp.data.code === 0) {
                        this.teacherList = resp.data.data.lists
                    } else {
                        this.$message({
                            message: resp.data.msg,
                            type: 'error'
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        remoteQueryTeacher(query) {
            if (query !== '') {
                this.queryTeacherLoading = true
                Axios.get('/basic/teacher/query_teacher', {
                    params: {
                        keyword: query
                    }
                })
                    .then((resp) => {
                        this.queryTeacherLoading = false
                        if (resp.data.code === 0) {
                            this.teacherList = resp.data.data && resp.data.data.lists
                        } else {
                            this.$message({
                                message: resp.data.msg,
                                type: 'error'
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.getAllTeacherList()
            }
        },
        editSubjectInfo(form) {
            let subjectDataArr = JSON.stringify(this.subjectDataArr)
            Axios.get('/api/baseinfo/schedule/update', {
                params: {
                    schedule_detail: subjectDataArr
                }
            })
                .then((resp) => {
                    const status = resp.data.status
                    if (status === '0') {
                        this.isChangeData = true
                        this.$message({ message: '修改成功', type: 'success' })
                        this.getTableList(this.formSearch) // 暂定
                        const subjectArr = resp.data.data
                        this.subjectDataArr = subjectArr
                        this.handleTableCellData(subjectArr)
                    } else {
                        this.$message({
                            message: resp.data.msg,
                            type: 'error'
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        deleteSubjectInfo(scheduleId, index) {
            Axios.get('/basic/schedule/delete_schedule', {
                params: {
                    id: scheduleId
                }
            })
                .then((resp) => {
                    if (resp.data.code === 0) {
                        this.isChangeData = true
                        this.$message({ message: '删除成功', type: 'success' })
                        //  this.subjectDataArr.splice(index, 1);
                        //  this.handleTableCellData(this.subjectDataArr);
                        this.getTableList(this.formSearch) // 暂定
                        this.checkboxGroup2 = []
                        this.students_num = 0
                        this.teacher_id = ''
                        this.subject_id = ''
                        this.subjectDataArr = null
                        this.get_disable_week()
                    } else {
                        this.$message({
                            message: resp.data.msg,
                            type: 'error'
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        handleCheckAllChange(val) {
            this.checkboxGroup2 = val
                ? Array(this.weeksCount)
                      .fill()
                      .map((_, i) => i + 1)
                : []
            this.isIndeterminate = false
        },
        handleCheckedWeekChange(value) {
            let checkedCount = value.length
            this.checkAll = checkedCount === this.weeksCount
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.weeksCount
        },
        /***********以下是私有方法*************/
        //  编辑季节作息时间
        editSuccess() {
            this.getTableList(this.formSearch)
        },
        editSeason() {
            this.$refs['SeasonEdit'].dialogVisible = true
        },
        clickCommitBtn1() {
            if (
                this.subjectDataArr &&
                this.subjectDataArr.length &&
                this.subjectDataArr[0] &&
                this.subjectDataArr[0].schedule_id !== '' &&
                this.subjectDataArr[0].schedule_id !== null
            ) {
                //  修改学科
                Axios.post('/basic/schedule/update_schedule', {
                    id: this.subjectDataArr[0].schedule_id,
                    rank: this.addForm.rank + 1,
                    week_day: this.selectWeek, // 1~7
                    subject: this.subject_id,
                    class_week: this.checkboxGroup2,
                    teacher: this.teacher_id,
                    students: this.students_num
                })
                    .then((resp) => {
                        if (resp.data.code === 0) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            })
                            this.getTableList(this.formSearch)
                            this.checkboxGroup2 = []
                            this.students_num = 0
                            this.teacher_id = ''
                            this.subject_id = ''
                            this.subjectDataArr = null
                        } else {
                            this.$message({
                                message: resp.data.msg,
                                type: 'error'
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                //  提交课表时默认选择教室
                if (!this.addForm.classroom_id) {
                    if (this.buildingForm.classroom_id) {
                        this.addForm.classroom_id = this.buildingForm.classroom_id
                    } else {
                        this.$message({
                            message: '请选择教室!',
                            type: 'error'
                        })
                    }
                }
                //  新增课表
                Axios.post('/basic/schedule/add_schedule', {
                    campus: this.buildingForm.campus_id,
                    term: this.addForm.term_id,
                    room: this.addForm.classroom_id,
                    rank: this.addForm.rank + 1,
                    week_day: this.selectWeek, // 1~7
                    subject: this.subject_id,
                    class_week: this.checkboxGroup2,
                    teacher: this.teacher_id,
                    students: this.students_num
                })
                    .then((resp) => {
                        if (resp.data.code === 0) {
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            })
                            this.getTableList(this.formSearch)
                            this.checkboxGroup2 = []
                            this.students_num = 0
                            this.teacher_id = ''
                            this.subject_id = ''
                            this.addForm.rank = ''
                            this.selectWeek = ''
                            this.isIndeterminate = false
                            this.subjectDataArr = null
                        } else {
                            this.$message({
                                message: resp.data.msg,
                                type: 'error'
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        clickCommitcancel() {
            this.checkboxGroup2 = [] //  清空选中的上课周
            this.isIndeterminate = false //  设置全选按钮非选中
            this.checkAll = false
        },

        filterNode(value, data) {
            if (!value) return true
            return data.label.indexOf(value) !== -1
        },
        handleTableData(responseData) {
            this.table_data = []
            let week1 = []
            let week2 = []
            let week3 = []
            let week4 = []
            let week5 = []
            let week6 = []
            let week7 = []
            responseData.forEach((element) => {
                let w1 = []
                let w2 = []
                let w3 = []
                let w4 = []
                let w5 = []
                let w6 = []
                let w7 = []
                element.schedule_detail[0].forEach((element) => {
                    //    w1 =
                    //      w1 + element.subject_name + ",\n(" + element.teacher_name + ")\n";
                    w1.push({
                        subName: element.subject_name,
                        teacherName: element.teacher_name
                    })
                })
                element.schedule_detail[1].forEach((element) => {
                    w2.push({
                        subName: element.subject_name,
                        teacherName: element.teacher_name
                    })
                })
                element.schedule_detail[2].forEach((element) => {
                    w3.push({
                        subName: element.subject_name,
                        teacherName: element.teacher_name
                    })
                })
                element.schedule_detail[3].forEach((element) => {
                    w4.push({
                        subName: element.subject_name,
                        teacherName: element.teacher_name
                    })
                })
                element.schedule_detail[4].forEach((element) => {
                    w5.push({
                        subName: element.subject_name,
                        teacherName: element.teacher_name
                    })
                })
                element.schedule_detail[5].forEach((element) => {
                    w6.push({
                        subName: element.subject_name,
                        teacherName: element.teacher_name
                    })
                })
                element.schedule_detail[6].forEach((element) => {
                    w7.push({
                        subName: element.subject_name,
                        teacherName: element.teacher_name
                    })
                })
                let itemDic = {
                    class_items: element.class_rank_name + '\n' + element.class_time,
                    week1: w1,
                    week2: w2,
                    week3: w3,
                    week4: w4,
                    week5: w5,
                    week6: w6,
                    week7: w7
                }
                this.table_data.push(itemDic)
            })
        },
        clickPreviousCourse() {
            this.index--
            //    this.index = this.subjectDataArr.findIndex(
            //      (item) => item.length === item.index
            //    );
            if (this.index < 0) {
                this.$message({
                    message: '已经是第一条数据',
                    type: 'warning'
                })
            }
            this.subject_id = this.subjectDataArr[this.index].subject_id
            this.teacher_id = this.subjectDataArr[this.index].teacher_id
            this.checkboxGroup2 = this.subjectDataArr[this.index].selected_week //  选中的周

            this.disabled_selected_week = this.subjectDataArr[this.index].disabled_selected_week.filter(
                (item) => item !== this.checkboxGroup2[0]
            )
            this.students_num = this.subjectDataArr[this.index].students
        },
        clickNextCourse() {
            //    this.index = this.subjectDataArr.findIndex(
            //      (item) => item.length === item.index
            //    );
            this.index++
            if (this.index >= this.subjectDataArr.length) {
                this.$message({
                    message: '已经是最后一条数据',
                    type: 'warning'
                })
            } else {
                this.subject_id = this.subjectDataArr[this.index].subject_id
                this.teacher_id = this.subjectDataArr[this.index].teacher_id
                this.checkboxGroup2 = this.subjectDataArr[this.index].selected_week //  选中的周
                this.disabled_selected_week = this.subjectDataArr[this.index].disabled_selected_week.filter(
                    (item) => item !== this.checkboxGroup2[0]
                )
                this.students_num = this.subjectDataArr[this.index].students
            }
        },
        handleNodeClick(data, node) {
            // 树点击事件
            switch (node.level) {
                case 1: //  校区
                    if (!this.buildingForm.campus_id || this.buildingForm.campus_id !== node.key) {
                        this.buildingForm.campus_id = data.id
                        this.buildingForm.campus_name = data.label
                        //  this.getAllTeacherList(node.key);  //  请求该校区下的教师列表
                    }
                    this.buildingForm.building_id = ''
                    this.buildingForm.building_name = ''
                    this.buildingForm.floor_id = ''
                    this.buildingForm.floor_name = ''
                    this.buildingForm.classroom_id = ''
                    this.buildingForm.classroom_name = ''
                    this.clickId = ''
                    break
                case 2: //  教学楼
                    if (!this.buildingForm.campus_id || this.buildingForm.campus_id !== node.parent.key) {
                        this.buildingForm.campus_id = node.parent.key
                        this.buildingForm.campus_name = node.parent.label
                    }
                    this.buildingForm.building_id = data.id
                    this.buildingForm.building_name = data.label
                    this.buildingForm.floor_id = ''
                    this.buildingForm.floor_name = ''
                    this.buildingForm.classroom_id = ''
                    this.buildingForm.classroom_name = ''
                    this.clickId = ''
                    break
                case 3: //  层
                    if (!this.buildingForm.campus_id || this.buildingForm.campus_id !== node.parent.parent.key) {
                        this.buildingForm.campus_id = node.parent.parent.key
                        this.buildingForm.campus_name = node.parent.parent.label
                    }
                    if (!this.buildingForm.building_id || this.buildingForm.building_id !== node.parent.key) {
                        this.buildingForm.building_id = node.parent.key
                        this.buildingForm.building_name = node.parent.label
                    }
                    this.buildingForm.floor_id = data.id
                    this.buildingForm.floor_name = data.label
                    this.buildingForm.classroom_id = ''
                    this.buildingForm.classroom_name = ''
                    this.clickId = ''
                    break
                case 4: //  教室
                    if (data.id === this.clickId) {
                        console.log('连续点击相同的教室')
                    } else {
                        this.addForm.rankStr = ''
                        this.subjectDataArr = []
                        this.clickId = data.id
                        if (!this.buildingForm.campus_id || this.buildingForm.campus_id !== node.parent.parent.parent.key) {
                            this.buildingForm.campus_id = node.parent.parent.parent.key
                            this.buildingForm.campus_name = node.parent.parent.parent.label
                        }
                        this.buildingForm.classroom_id = data.id
                        this.buildingForm.classroom_name = data.label
                        this.buildingForm.building_id = node.parent.parent.key
                        this.buildingForm.building_name = node.parent.parent.label
                        this.buildingForm.floor_id = node.parent.key
                        this.buildingForm.floor_name = node.parent.label

                        this.getTableList(this.formSearch)
                        break
                    }
            }
        },
        // 设置指定行、列、具体单元格颜色
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                // 指定坐标rowIndex ：行，columnIndex ：列
                return 'background:#dcdfe6;color:#333' // rgb(105,0,7)
            } else {
                if (this.row === row && this.column === column) {
                    return 'background-color:#8aacec;color:#fff'
                } else {
                    return 'background-color:#fff;color:#333'
                }
            }
        },
        clickTableCell(row, column, event, cell) {
            this.index = 0
            //  课表单元格点击事件
            if (!row.class_items || !column.label) {
                return
            }
            this.row = row
            this.column = column
            this.students_num = 0
            var rowIndex = 0
            var columnIndex = 0
            let arr = row.class_items.split('\n')
            this.rank_lisk.map((item) => {
                if (item.rank === arr[0]) {
                    rowIndex = item.id
                }
            })
            switch (column.label) {
                case '星期一':
                    {
                        columnIndex = 0
                    }
                    break
                case '星期二':
                    {
                        columnIndex = 1
                    }
                    break
                case '星期三':
                    {
                        columnIndex = 2
                    }
                    break
                case '星期四':
                    {
                        columnIndex = 3
                    }
                    break
                case '星期五':
                    {
                        columnIndex = 4
                    }
                    break
                case '星期六':
                    {
                        columnIndex = 5
                    }
                    break
                case '星期日':
                    {
                        columnIndex = 6
                    }
                    break

                default:
                    break
            }
            this.rowIndex = rowIndex
            this.columnIndex = columnIndex
            this.addForm.rank = rowIndex
            this.addForm.rankStr = row.class_items
            this.addForm.week_day = columnIndex + 1
            this.selectWeek = columnIndex + 1
            this.addForm.classroom_id = this.buildingForm.classroom_id
            this.addForm.classroom_name = this.buildingForm.classroom_name
            this.addForm.building_name = this.buildingForm.building_name
            this.addForm.floor_name = this.buildingForm.floor_name
            this.checkboxGroup2 = []
            this.disabled_selected_week = []
            this.isIndeterminate = this.selected_week.length > 0
            this.subjectDataArr = this.responseData[rowIndex].schedule_detail[columnIndex] // JSON.parse(JSON.stringify());
            // let data = deepClone(this.responseData)
            // 区分是新增还是编辑
            this.get_disable_week() //  获取禁用的周
            if (this.subjectDataArr.length > 0) {
                if (
                    this.subjectDataArr[0] &&
                    this.subjectDataArr[0].schedule_id !== '' &&
                    this.subjectDataArr[0].schedule_id !== null
                ) {
                    this.isEditSubjectInfo = true
                    this.subject_id = this.subjectDataArr[0].subject_id
                    this.teacher_id = this.subjectDataArr[0].teacher_id
                    this.checkboxGroup2 = this.subjectDataArr[0].selected_week //  选中的周
                    this.disabled_selected_week = this.subjectDataArr[0].disabled_selected_week.filter(
                        (item) => item !== this.checkboxGroup2[0]
                    )
                    this.students_num = this.subjectDataArr[0].students
                } else {
                    this.subject_id = ''
                    this.teacher_id = ''
                    this.isEditSubjectInfo = false
                }
            } else {
                this.subject_id = ''
                this.teacher_id = ''
            }
            this.isIndeterminate = this.checkboxGroup2.length > 0
            this.checkAll = this.checkboxGroup2.length === this.weeksCount

            if (this.checkAll) {
                this.isIndeterminate = false
            }
        },

        addObject() {
            this.checkboxGroup2 = [this.currentWeek]
            this.students_num = 0
            this.teacher_id = ''
            this.subject_id = ''
            this.subjectDataArr = null
            //  this.get_disable_week();
        },
        get_disable_week() {
            if (
                this.subjectDataArr &&
                this.subjectDataArr[0] &&
                this.subjectDataArr[0].schedule_id !== '' &&
                this.subjectDataArr[0].schedule_id !== null
            ) {
                return
            }
            if (this.addForm.term_id && this.buildingForm.classroom_id && this.addForm.rank + 1 && this.selectWeek) {
                Axios.get('/basic/schedule/get_disable_week', {
                    params: {
                        term: this.addForm.term_id,
                        room: this.buildingForm.classroom_id,
                        rank: this.addForm.rank + 1,
                        week_day: this.selectWeek // 1~7
                    }
                })
                    .then((resp) => {
                        if (resp.data.code === 0) {
                            this.disabled_selected_week = resp.data.data
                        } else {
                            this.$message({
                                message: resp.data.msg,
                                type: 'error'
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        deleteSubject(index) {
            let model = this.subjectDataArr[this.index]
            if (model.schedule_id) {
                this.$confirm('确认删除该学科?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true,
                    showClose: false
                })
                    .then(() => {
                        this.deleteSubjectInfo(model.schedule_id, this.index)
                    })
                    .catch(() => {})
            } else {
                this.subjectDataArr.splice(index, 1)
            }
        },

        handleTableCellData(subjectArr) {
            var week = ''
            subjectArr.forEach((element) => {
                week = week + '*' + element.subject_name + ',' + '\n' + element.week + ',\n' + element.teacher_name + ';\n'
            })

            switch (this.columnIndex) {
                case 0:
                    {
                        this.table_data[this.rowIndex].week1 = week
                    }
                    break
                case 1:
                    {
                        this.table_data[this.rowIndex].week2 = week
                    }
                    break
                case 2:
                    {
                        this.table_data[this.rowIndex].week3 = week
                    }
                    break
                case 3:
                    {
                        this.table_data[this.rowIndex].week4 = week
                    }
                    break
                case 4:
                    {
                        this.table_data[this.rowIndex].week5 = week
                    }
                    break
                case 5:
                    {
                        this.table_data[this.rowIndex].week6 = week
                    }
                    break
                case 6:
                    {
                        this.table_data[this.rowIndex].week7 = week
                    }
                    break
                default:
                    break
            }
        },
        selectTerm(val) {
            if (val) {
                this.addForm.term_id = this.formSearch.term_id
                this.all_term_map[this.buildingForm.campus_id].map((item) => {
                    if (item.term === val) {
                        this.currentWeek = item.current_week ? item.current_week : 1
                        this.weeksCount = item.week
                        this.formSearch.termStr = item.term_name
                        this.addForm.termInfo = item.period_name + '~' + item.term_name
                    }
                })
                this.getTableList(this.formSearch)
            } else {
                this.addForm.term_id = this.formSearch.term_id = this.addForm.termInfo = ''
            }
        },
        onWeekChange(val) {
            this.cellColIndex = val
            this.selectClickCell()
        },
        onRankChange(val) {
            this.cellRowIndex = val
            this.selectClickCell()
        },
        selectClickCell() {
            let table = this.$refs.table
            let cell = table.$el.childNodes[2].childNodes[0].childNodes[1].childNodes[this.cellRowIndex].cells[this.cellColIndex]
            cell.click()
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    min-width: 1590px;
    margin: 10px;
    :deep(.el-checkbox-group) {
        label {
            margin-right: 10px;
            margin-bottom: 5px;
            span {
                border: 1px solid #dcdfe6;
                padding: 5px 4px;
                width: 26px;
            }
        }
    }
    .el-header {
        background-color: #fff;
        color: #333;
        line-height: 60px;
    }

    .el-aside {
        color: #333;
    }

    .el-main {
        flex: none;
    }

    :deep(.el-table .cell) {
        // 单元格有\n时换行显示
        white-space: pre-line;
    }
    :deep(.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content) {
        background-color: var(--theme-color);
        color: #fff;
    }
    .seasonInfo {
        display: flex;
        padding-left: 20px;
        align-items: center;
        .seasonBg {
            margin-right: 10px;
            box-sizing: border-box;
            width: 70px;
            height: 70px;
            text-align: center;
            line-height: 70px;
            font-size: 18px;
            font-weight: 600;
        }
        .setting {
            margin-left: auto;
            margin-right: 20px;
        }
    }
    :deep(.el-input--suffix .el-input__inner) {
        padding-right: 30px;
        margin-top: 4px;
    }
}
</style>
